import { __ } from '../../utils';
import { Box, ButtonBase } from '@presov.sk/presov-ui-react';
import React from 'react';

export type FeedSegmentValue = 'reports' | 'news';

type Props = {
  value: FeedSegmentValue;
  onChange: (value: FeedSegmentValue) => void;
};

const OPTIONS: { value: FeedSegmentValue; label: string }[] = [
  { value: 'reports', label: __('Podnety') },
  { value: 'news', label: __('Novinky mesta') },
];

/**
 * Prvý riadok panela. Nahradil tri nezávislé zaškrtávacie filtre (Novinky,
 * Moje podnety, Verejné podnety): tri prepínače nad jedným zoznamom
 * dovoľovali stav „nič nie je zapnuté", z ktorého sa prázdny zoznam nedal
 * odlíšiť od zoznamu bez výsledkov. Segment je vždy práve jeden.
 */
const FeedSegment: React.FC<Props> = ({ value, onChange }) => (
  <Box
    role='tablist'
    sx={(theme) => ({
      flex: 'none',
      display: 'flex',
      gap: 0.5,
      padding: 0.5,
      borderRadius: `${theme.typography.pxToRem(14)}`,
      backgroundColor: theme.palette.grey[100],
    })}
  >
    {OPTIONS.map((option) => {
      const active = option.value === value;

      return (
        <ButtonBase
          key={option.value}
          role='tab'
          aria-selected={active}
          onClick={() => onChange(option.value)}
          sx={(theme) => ({
            flex: 1,
            height: theme.typography.pxToRem(38),
            borderRadius: `${theme.typography.pxToRem(11)}`,
            fontSize: theme.typography.pxToRem(14),
            fontWeight: 700,
            backgroundColor: active
              ? theme.palette.background.paper
              : 'transparent',
            color: active
              ? theme.palette.text.primary
              : theme.palette.grey[500],
            boxShadow: active ? theme.overlayShadow.band : 'none',
          })}
        >
          {option.label}
        </ButtonBase>
      );
    })}
  </Box>
);

export default FeedSegment;
